import { StockStatus } from '~/shared/utils/getStockStatus';

const getBOPSStockStatus = (storeLocation, warehouseInventory) => {
  if (!storeLocation.bopsAllowed) {
    return StockStatus.BOPS_UNAVAILABLE;
  }
  if (warehouseInventory.quantity < storeLocation.bopsMinInventory) {
    return StockStatus.SOLD_OUT;
  }
  if (
    warehouseInventory.quantity > storeLocation.bopsMinInventory &&
    warehouseInventory.quantity <= storeLocation.bopsLowStkInventory + 2
  ) {
    return StockStatus.LOW_STOCK;
  }
  return StockStatus.OK;
};
export default getBOPSStockStatus;
